export default __webpack_public_path__ + "static/media/Cashmere.e31de2a5.png";